/**
 *
 * Asynchronously loads the component for CallsComponent
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CallsComponent = lazyLoad(
  () => import('./index'),
  module => module.CallsComponent,
);
